<template>
  <!-- 维护资质要求 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogShow"
    width="77%"
    :before-close="dialogCloseBefore"
  >
    <div class="search-wrapper">
      <div class="tab-wrapper">
        <el-button
          :type="isFocus === 1 ? 'table-top-active' : 'table-top'"
          size="mini"
          >{{ activeName }}</el-button
        >
      </div>
    </div>
    <div style="font-size: 13px; margin: 15px 0">
      各类供应商申请与本单位合作时的资质文件要求
    </div>
    <!--     列表-->
    <div class="multifunctional-table-wrapper-tree">
      <div class="multifunctional-table-wrapper">
        <el-table
          :data="tableData"
          row-key="supplierTypeCode"
          border
          :max-height="tableMaxHeight"
          :tree-props="{ children: 'children' }"
          :default-expand-all="true"
          class="multifunctional-table"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            prop="supplierTypeName"
            label="供应商分类"
            :fixed="true"
            width="180"
          >
          </el-table-column>
          <el-table-column
            class="noWeight"
            v-for="(item, index) in columns"
            :key="index"
            :label="item.label"
            width="180"
            :prop="item.prop"
          >
            <template v-slot:header>
              <el-checkbox
                :value="getHeaderCheckboxStatus(item.id)"
                @change="
                  data => {
                    headerCheckboxChange(item.id, data);
                  }
                "
                :style="{ marginRight: '5px' }"
              ></el-checkbox>
              <span>{{ item.aptitudeName }}</span>
            </template>
            <template slot-scope="scope">
              <el-checkbox
                v-if="scope.row.children.length <= 0"
                :value="getCheckboxStatus(item.id, scope.row.id)"
                @change="
                  data => {
                    checkboxChange(item.id, scope.row.id, data);
                  }
                "
              ></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="diaCancelHandle"
        >取消</el-button
      >
      <el-button size="mini" type="primary-font-mini" @click="diaSureHandle"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  qrySupplierClassifyTree,
  maintainAptitudeRequire,
  qryAptitudeFile,
  qryAptitudeRequire
} from "../api/appSet";

export default {
  name: "baseOpera-digRequire",
  props: ["acvivetab"],
  data() {
    return {
      title: "维护资质要求",
      isFocus: 1,
      dialogShow: true,
      columns: [],
      tableData: [],
      fatherTableData: [],
      checkboxData: [], // 最终选择的所有资质文件
      oldCheckboxData: [], // 默认选中的所有资质文件
      checkValue: false,
      // 展开行的数组
      expandRowKeys: [],
      tableMaxHeight: window.screen.height * 0.4
    };
  },
  created() {
    this.getTree();
  },
  mounted() {
    // 初始状态展开第一个树
    // this.expandRowKeys.push(this.tableData[0].supplierTypeCode);
  },
  computed: {
    // 纵向选项的总条数，用来判断是否全选
    tableRowLen() {
      return this.getChildrenlen(this.tableData);
    },
    activeName() {
      return this.acvivetab === "A"
        ? "工程类"
        : this.acvivetab == "B"
        ? "物资类"
        : "服务类";
    }
  },
  methods: {
    // 点击任意地方
    dialogCloseBefore() {
      this.dialogShow = false;
      this.$emit("requireDialogCancel", this.dialogShow);
    },
    // 基础数据-查询供应商类型树
    getTree() {
      // 页签ID：01-物资供应商 02-装备供应商 03-分包商
      const obj = { supplierTypeCode: this.acvivetab };
      qrySupplierClassifyTree(obj).then(res => {
        // 遍历所有的节点个数从第一级遍历
        this.fatherTableData = res.data.data;
        if (res.data.data && res.data.data.length > 0) {
          var test = res.data.data.map(item => {
            item.isLeaf = item.isLeaf === "1";
            return item;
          });
          this.tableData = test;
          console.log(this.tableData);
        }
      });
      // 资质要求-根据采购单位查询资质文件
      const objFile = { isDisplayDefault: 1 };
      qryAptitudeFile(objFile).then(res => {
        res.data.data.aptitudeFiles.forEach(function(item, i) {
          item.label = item.aptitudeName;
          item.prop = "gradeFile";
        });
        this.columns = res.data.data.aptitudeFiles;
        console.log(this.columns);
      });
      // 被选中的资质接口;
      console.log(this.acvivetab);
      const objRequire = { tabId: this.acvivetab };
      qryAptitudeRequire(objRequire).then(res => {
        this.oldCheckboxData = res.data.data;
        this.checkboxData = [...this.oldCheckboxData];
      });
    },
    // 弹框取消按钮
    diaCancelHandle() {
      this.dialogShow = false;
      this.$emit("requireDialogCancel", this.dialogShow);
    },
    // 弹框确定按钮
    diaSureHandle() {
      this.dialogShow = false;
      let deleteIds = [];
      let aptitudeRequires = [...this.checkboxData];
      this.oldCheckboxData.forEach(item => {
        let isData = this.checkboxData.findIndex(value => {
          return (
            value.aptitudeId === item.aptitudeId &&
            value.supplierId === item.supplierId
          );
        });
        if (isData === -1) {
          deleteIds.push(item.id);
        }
      });
      // 修改资质文件后调的接口
      const objReq = {
        aptitudeRequires: aptitudeRequires,
        deleteIds: deleteIds,
        isShowLoading: true,
        loadingMessage: "提交中,请稍等..."
      };
      maintainAptitudeRequire(objReq)
        .then(res => {
          this.$emit("requireDialogSure", this.dialogShow);
          this.$emit("diaCheckData", this.checkboxData);
          this.$message({
            message: "资质文件修改成功！",
            type: "success",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 全选checkbox的状态获取
    getHeaderCheckboxStatus(aptitudeId) {
      let checkedLen = this.checkboxData.filter(item => {
        return item.aptitudeId === aptitudeId;
      }).length;
      return checkedLen === this.tableRowLen;
    },
    // 全选checkbox点击事件
    headerCheckboxChange(aptitudeId, data) {
      let checkboxData = this.checkboxData;
      // 存放弹框进来时的选择数据
      let checkboxDataSid = [...this.checkboxData];
      // 先取消所有的选择
      for (let i = checkboxData.length - 1; i >= 0; i--) {
        checkboxData[i].aptitudeId === aptitudeId && checkboxData.splice(i, 1);
      }
      if (data) {
        let func = tableData => {
          tableData.forEach((item, index) => {
            if (item.children.length > 0) {
              func(item.children);
            } else {
              checkboxData.push({
                aptitudeId,
                supplierId: item.id
              });
            }
          });
        };
        func(this.tableData);
      }
      // 为弹框进来时的数据加id
      checkboxDataSid.forEach(item => {
        for (let i = 0; i < checkboxData.length; i++) {
          if (
            item.aptitudeId === checkboxData[i].aptitudeId &&
            item.supplierId === checkboxData[i].supplierId
          ) {
            checkboxData[i].id = item.id;
            break;
          }
        }
      });
    },
    // 递归获取子元素的数量
    getChildrenlen(tableData) {
      let len = 0;
      tableData.forEach(item => {
        if (item.children && item.children.length > 0) {
          len += this.getChildrenlen(item.children);
        } else {
          len++;
        }
      });
      return len;
    },
    // 获得资质文件的选中状态
    getCheckboxStatus(aptitudeId, supplierId) {
      return this.checkboxData.some(value => {
        return (
          value.aptitudeId === aptitudeId && value.supplierId === supplierId
        );
      });
    },
    checkboxChange(aptitudeId, supplierId, data) {
      // 复选框的选中未选中状态
      const checkboxData = this.checkboxData;
      if (data) {
        checkboxData.push({
          aptitudeId,
          supplierId
        });
      } else {
        let ret = checkboxData.findIndex(value => {
          return (
            value.aptitudeId === aptitudeId && value.supplierId === supplierId
          );
        });
        ret !== -1 && checkboxData.splice(ret, 1);
      }
      // 为弹框进来时的数据加id，这样认为是之前就有的数据
      this.oldCheckboxData.forEach(item => {
        for (let i = 0; i < checkboxData.length; i++) {
          if (
            item.aptitudeId === checkboxData[i].aptitudeId &&
            item.supplierId === checkboxData[i].supplierId
          ) {
            checkboxData[i].id = item.id;
            break;
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.app-container .search-wrapper .tab-wrapper {
  top: 0;
}

/deep/ .el-dialog__body {
  padding: 0 20px 20px;
}

/deep/ .el-dialog__title {
  font-size: 14px;
  font-weight: 600;
}

/deep/ .el-dialog__header {
  padding: 9px 0 2px 17px;
}

/deep/ .tab-wrapper .el-button.el-button--mini {
  padding: 15px 0 1px 0;
}

/deep/ .multifunctional-table-wrapper .el-table th {
  &:not(:first-child) {
    .cell {
      font-weight: 500 !important;
    }
  }
}
</style>
